_getRouteInfo